import PropTypes from 'prop-types';
import React from 'react';

import s from './DealCardProductWrap.scss';
import cls from 'classnames/bind';

import FormattedDate from '@ott/formatted-date';
import FormattedPeriod from '@ott/formatted-period';
import { l10n } from '@ott/l10n';
import Money from '@ott/money';
import StarRating from '@ott/star-rating';

import { LABEL_TYPES, PRODUCTS } from '../../constants';
import DealCard from '../DealCard';

const cx = cls.bind(s);

class DealCardProductWrap extends React.PureComponent {
  static propTypes = {
    data: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)),
    product: PropTypes.string,
    defaultBackgroundImageUrl: PropTypes.string,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    data: {},
    defaultBackgroundImageUrl: '',
    onClick: () => {},
  };

  getFormattedDates(dates) {
    if (!dates) {
      return null;
    }

    if (!dates.end) {
      return <FormattedDate date={dates.start} />;
    }

    return <FormattedPeriod startDate={dates.start} endDate={dates.end} />;
  }

  getDealCardProps(product, data) {
    switch (product) {
      case PRODUCTS.avia: {
        return {
          ...data,
          href: data.href,
          backgroundImageUrl: data.backgroundImageUrl,

          type: null,
          labelType: null,
          label: null,

          leftPreTitle: null,
          leftTitle: data.title,
          leftSubTitle: this.getFormattedDates(data.dates),

          rightPreTitle: data.prevPrice && (
            <Money
              amount={data.prevPrice}
              currency={data.currency}
              className={cx('prevPrice')}
              useSymbol={false}
            />
          ),
          rightTitle: (
            <Money amount={data.price} currency={data.currency} className={cx('price')} />
          ),
          rightSubTitle: data.isRoundTrip ? l10n('deals.roundTrip') : ' ',
        };
      }
      case PRODUCTS.cars: {
        return {
          ...data,
          href: data.href,
          backgroundImageUrl: data.backgroundImageUrl,

          type: null,
          labelType: null,
          label: null,

          leftPreTitle: null,
          leftTitle: data.cityName,
          leftSubTitle: data.countryName,
          rightTitle: (
            <Money amount={data.price} currency={data.currency} className={cx('price')} />
          ),
          rightSubTitle: 'аренда в день',
        };
      }
      case PRODUCTS.hotels: {
        return {
          ...data,
          href: data.href,
          backgroundImageUrl: data.backgroundImageUrl,

          type: null,
          labelType: null,
          label: null,

          leftPreTitle: null,
          leftTitle: data.cityName,
          leftSubTitle: data.countryName,

          rightPreTitle: null,
          rightTitle: (
            <Money amount={data.price} currency={data.currency} className={cx('price')} />
          ),
          rightSubTitle: l10n('deals.nightsCountAndGuests', { nights: data.nights }),
        };
      }
      case PRODUCTS.poezda: {
        return {
          ...data,
          href: data.href,
          backgroundImageUrl: data.backgroundImageUrl,

          type: null,
          labelType: null,
          label: null,

          leftPreTitle: (
            <span>
              {data.from}
              &nbsp;&mdash;
            </span>
          ),
          leftTitle: data.to,
          leftSubTitle: this.getFormattedDates(data.dates),
          rightPreTitle: null,
          rightTitle: (
            <Money amount={data.price} currency={data.currency} className={cx('price')} />
          ),
          rightSubTitle: data.train,
        };
      }
      case PRODUCTS.bus: {
        return {
          ...data,
          href: data.href,
          backgroundImageUrl: data.backgroundImageUrl,

          type: null,
          labelType: null,
          label: null,

          leftPreTitle: `${data.departure} —`,
          leftTitle: data.destination,
          leftSubTitle: null,

          rightPreTitle: null,
          rightTitle: null,
          rightSubTitle: null,
        };
      }
      case PRODUCTS.bundles: {
        return {
          ...data,
          href: data.href,
          backgroundImageUrl: data.backgroundImageUrl,

          type: l10n('deals.types.packages').toUpperCase(),
          labelType: LABEL_TYPES.discount,
          label: `–${data.discountPercent}%`,

          leftPreTitle: (
            <>
              <StarRating rating={data.hotelStars} />
              <br />
              {data.hotelName}
            </>
          ),
          leftTitle: data.cityName,
          leftSubTitle: data.country,

          rightPreTitle: data.prevPrice && (
            <Money amount={data.prevPrice} currency={data.currency} className={cx('prevPrice')} />
          ),
          rightTitle: (
            <>
              {l10n('deals.startingFrom')}{' '}
              <Money amount={data.price} currency={data.currency} className={cx('price')} />
            </>
          ),
          rightSubTitle: this.getFormattedDates(data.dates),
        };
      }
      default:
        return data;
    }
  }

  render() {
    const { onClick, data, product, defaultBackgroundImageUrl, trackClick, openNewWindow } =
      this.props;

    const dealCardProps = this.getDealCardProps(product, data);

    return (
      <DealCard
        onClick={onClick}
        defaultBackgroundImageUrl={defaultBackgroundImageUrl}
        trackClick={trackClick}
        product={product}
        openNewWindow={openNewWindow}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...dealCardProps}
      />
    );
  }
}

export default DealCardProductWrap;
